export const JomBizKYCCustomer = {
  content: {
    type: 'modal',
    width: 1200,
    bodyStyle: {
      paddingTop: '20px'
    },
    openActionKey: 'showKYC',
    closeActionKey: 'CLOSE_KYC',
    title: 'Complete Your KYC',
    children: [
      {
        type: 'form',
        formRef: 'kycForm',
        onInitial: 'onInitialtKYCForm',
        onFinish: 'onSubmitKYCForm',
        onChange: 'ON_CHANGE_KYC_FORM',
        children: [
          { // Personal Information: Documents
            type: 'card',
            title: {
              type: 'text',
              content: '{{PERSONAL_INFORMATION}}'
            },
            headStyle: { background: '$primary', color: '!primary' },
            children: [
              {
                type: 'div',
                className: 'row align-items-end',
                children: [
                  {
                    type: 'div',
                    className: 'col-4',
                    children: [
                      {
                        type: 'select',
                        label: "{{REGISTRATION_TYPE}}",
                        name: 'document_type',
                        inputConfig: {
                          placeholder: "{{REGISTRATION_TYPE}}",
                          size: 'large',
                          dataKey: 'documentOption',
                          label: 'label',
                          value: 'value',
                        },
                        roleConfig: true
                      }
                    ]
                  },
                  {
                    type: 'div',
                    className: 'col-8',
                    children: [
                      {
                        type: 'input',
                        label: "{{IDENTITY_NUMBER}}",
                        // rules: [
                        //   {
                        //     validator: (_, value, callback, form) => {
                        //       const docType = form.getFieldValue('document_type');
                        //       const skipValidation = ['passport', 'ssm'].includes(docType?.toLowerCase());

                        //       if (skipValidation) {
                        //         // No validation at all
                        //         return Promise.resolve();
                        //       }

                        //       if (!value) {
                        //         return Promise.reject(new Error(`{{PLEASE_ENTER}} {{IDENTITY_NUMBER}}`));
                        //       }

                        //       const numericOnly = /^[0-9]+$/;
                        //       if (!numericOnly.test(value)) {
                        //         return Promise.reject(new Error('{{ONLY_NUMBERS_IS_ACCEPTABLE}}'));
                        //       }

                        //       return Promise.resolve();
                        //     }
                        //   }
                        // ],


                        name: 'ic_number',
                        inputConfig: {
                          size: 'large'
                        },
                        roleConfig: true
                      }
                    ]
                  }
                ]
              },
              {
                type: 'div',
                className: 'row align-items-end',
                children: [
                  {
                    type: 'div',
                    className: 'col-md-6',
                    children: [
                      {
                        type: 'input',
                        variant: 'datepicker',
                        rules: [

                        ],
                        // rules: [
                        //   {
                        //     validator: (_, value, callback, form) => {
                        //       const docType = form.getFieldValue('document_type');

                        //       const skipValidation = ['passport', 'business_registration_number'].includes(docType?.toLowerCase());

                        //       if (skipValidation) {
                        //         return Promise.resolve();
                        //       }

                        //       if (!value) {
                        //         return Promise.reject('{{PLEASE_ENTER_YOUR}} {{DATE_OF_BIRTH}}');
                        //       }

                        //       return Promise.resolve();
                        //     }
                        //   }
                        // ],
                        label: "{{DATE_OF_BIRTH}}",
                        name: 'date_of_birth',
                        inputConfig: {
                          style: { width: '100%' },
                          placeholder: "{{DOB}}",
                          size: 'large'
                        }
                      }
                    ]
                  },
                  {
                    type: 'div',
                    className: 'col-md-6',
                    children: [
                      {
                        type: 'select',
                        label: "{{GENDER}}",
                        name: 'gender',
                        inputConfig: {
                          placeholder: "{{GENDER}}",
                          dataKey: 'genderOptions',
                          size: 'large',
                          label: 'name',
                          value: 'value',
                          isDisabled: 'disabledGender'
                        }
                      }
                    ]
                  }
                ]
              },
              {
                type: 'div',
                className: 'row',
                children: [
                  {
                    type: 'div',
                    className: 'col-6',
                    children: [
                      {
                        type: 'text',
                        content: '<span style="color: #ff0000;">* </span> {{FRONT_IC_OR_PASSPORT}}'
                      },
                      {
                        type: 'file-pond',
                        files: 'uploadedICFront',
                        acceptedFileTypes: ['image/*'],
                        allowMultiple: false,
                        returnFileInfo: true,
                        actionKey: 'UPLOAD_IC_FRONT'
                      },
                      {
                        type: 'text',
                        isHide: 'hideFormFeedbackICFront',
                        className: 'text-danger',
                        content: "{{PLEASE_UPLOAD_IC_FRONT}}"
                      }
                    ]
                  },
                  {
                    type: 'div',
                    className: 'col-6',
                    isHide: 'hideBackIC',
                    children: [
                      {
                        type: 'text',
                        content: `<span style="color: #ff0000;">* </span>{{BACK_IC}}`
                      },
                      {
                        type: 'file-pond',
                        files: 'uploadedICBack',
                        acceptedFileTypes: ['image/*'],
                        allowMultiple: false,
                        returnFileInfo: true,
                        actionKey: 'UPLOAD_IC_BACK'
                      },
                      {
                        type: 'text',
                        isHide: 'hideFormFeedbackICBack',
                        className: 'text-danger',
                        content: "{{PLEASE_UPLOAD_IC_BACK}}"
                      }
                    ]
                  }
                ]
              },
              {
                type: 'div',
                className: 'row',
                isHide: 'hideSSM',
                children: [
                  {
                    type: 'div',
                    className: 'col-6',
                    children: [
                      {
                        type: 'text',
                        content: '<span style="color: #ff0000;">* </span> {{SSM_REGISTRATION_CERT}}'
                      },
                      {
                        type: 'file-pond',
                        files: 'uploadedSSMCert',
                        acceptedFileTypes: ['image/*'],
                        allowMultiple: false,
                        returnFileInfo: true,
                        actionKey: 'UPLOAD_SSM_CERT'
                      },
                      {
                        type: 'text',
                        isHide: 'hideFormFeedbackSSMCert',
                        className: 'text-danger',
                        content: "{{PLEASE_UPLOAD_SSM_CERT}}"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          { // Address
            type: 'card',
            title: {
              type: 'text',
              content: '{{ADDRESS}}'
            },
            isHide: 'hideAddressForm',
            headStyle: { background: '$primary', color: '!primary' },
            children: [
              {
                type: 'div',
                className: 'row',
                children: [
                  {
                    type: 'input',
                    className: 'col-md-4',
                    rules: [{ required: true, message: `{{PLEASE_ENTER_YOUR}} {{ADDRESS}}` }],
                    label: '{{ADDRESS_LINE_1}}',
                    name: 'address_line1',
                    inputConfig: {
                      placeholder: '{{ADDRESS_LINE_1}}',
                      size: 'large'
                    }
                  },
                  {
                    type: 'input',
                    className: 'col-md-4',
                    label: '{{ADDRESS_LINE_2}}',
                    name: 'address_line2',
                    inputConfig: {
                      placeholder: '{{ADDRESS_LINE_2}}',
                      size: 'large'
                    }
                  },
                  {
                    type: 'input',
                    className: 'col-md-4',
                    label: '{{ADDRESS_LINE_3}}',
                    name: 'address_line3',
                    inputConfig: {
                      placeholder: '{{ADDRESS_LINE_3}}',
                      size: 'large'
                    }
                  },
                  {
                    type: 'input',
                    className: 'col-md-3',
                    rules: [{ required: true, message: `{{PLEASE_ENTER_YOUR}} {{POSTCODE}}` }],
                    label: '{{POSTCODE}}',
                    name: 'postcode',
                    inputConfig: {
                      placeholder: '{{POSTCODE}}',
                      size: 'large'
                    }
                  },
                  {
                    type: 'select',
                    className: 'col-md-3',
                    rules: [{ required: true, message: `{{PLEASE_ENTER_YOUR}} {{COUNTRY}}` }],
                    label: '{{COUNTRY}}',
                    name: 'country_iso2',
                    inputConfig: {
                      placeholder: '{{COUNTRY}}',
                      size: 'large',
                      dataKey: 'countriesOption',
                      label: 'name',
                      value: 'iso2'
                    }
                  },
                  {
                    type: 'select',
                    className: 'col-md-3',
                    rules: [{ required: true, message: `{{PLEASE_ENTER_YOUR}} {{STATE}}` }],
                    label: '{{STATE}}',
                    name: 'state',
                    inputConfig: {
                      placeholder: '{{STATE}}',
                      size: 'large',
                      dataKey: 'statesOption',
                      label: 'name',
                      value: 'name'
                    }
                  },
                  {
                    type: 'input',
                    className: 'col-md-3',
                    variant: 'auto-complete',
                    rules: [{ required: true, message: `{{PLEASE_ENTER_YOUR}} {{CITY}}` }],
                    label: '{{CITY}}',
                    name: 'city',
                    inputConfig: {
                      placeholder: '{{CITY}}',
                      size: 'large',
                      dataKey: 'citiesOption',
                      label: 'name',
                      value: 'name'
                    }
                  }
                ]
              }
            ]
          },
          { // Bank Details
            type: 'card',
            title: {
              type: 'text',
              content: "{{BANK_DETAIL}}"
            },
            headStyle: { background: '$primary', color: '!primary' },
            children: [
              {
                type: 'div',
                className: 'row',
                children: [
                  {
                    type: 'div',
                    className: 'col-md-6',
                    children: [
                      {
                        type: 'select',
                        label: "{{BANK_NAME}}",
                        name: 'bank_id',
                        rules: [{ required: true, message: "{{SELECT_YOUR_BANK}}" }],
                        actionKey: 'SELECT_YOUR_BANK',
                        inputConfig: {
                          placeholder: "{{SELECT_YOUR_BANK}}",
                          size: 'large',
                          dataKey: 'banks',
                          label: 'label',
                          value: 'id'
                        }
                      }
                    ]
                  },
                  {
                    type: 'div',
                    className: 'col-md-6',
                    children: [
                      {
                        type: 'input',
                        label: "{{BANK_ACCOUNT_NO}}",
                        rules: [{ required: true, message: `{{PLEASE_ENTER}} {{BANK_ACCOUNT_NO}}` }, { pattern: /^[0-9]*$/, message: "{{ONLY_NUMBERS}}" }],
                        name: 'account_number',
                        inputConfig: {
                          placeholder: "{{BANK_ACCOUNT_NO}}",
                          min: 0,
                          style: { width: '100%' }
                        }
                      }
                    ]
                  }
                ]
              },
              {
                type: 'div',
                className: 'row',
                children: [
                  {
                    type: 'div',
                    className: 'col-md-6',
                    children: [
                      {
                        type: 'input',
                        label: "{{HOLDER_NAME}}",
                        name: 'holder_name',
                        rules: [{ required: true, message: "{{PLEASE_ENTER}} {{HOLDER_NAME}}" }],
                        inputConfig: {
                          placeholder: "{{HOLDER_NAME}}",
                          size: 'large',
                          style: { width: '100%' }
                        }
                      }
                    ]
                  },
                ]
              },
              { // Account ownership
                type: 'div',
                className: 'row',
                children: [
                  {
                    type: 'div',
                    className: 'col-md-6',
                    children: [
                      {
                        type: 'select',
                        label: '{{ACCOUNT_OWNERSHIP}}',
                        name: 'account_ownership',
                        rules: [{ required: true, message: "{{PLEASE_SELECT}} {{ACCOUNT_OWNERSHIP}}" }],
                        inputConfig: {
                          placeholder: '{{ACCOUNT_OWNERSHIP}}',
                          size: 'large',
                          dataKey: 'accountOwnershipOptions',
                          label: 'name',
                          value: 'value'
                        }
                      }
                    ]
                  },
                ]
              },
              { // Account ownership message
                type: 'div',
                className: 'row pb-2',
                isHide: 'hideAccountOwnerShipMessage',
                children: [
                  {
                    type: 'div',
                    className: 'col-md-12 d-flex align-items-center',
                    children: [
                      {
                        type: 'text',
                        style: { fontStyle: 'italic' },
                        content: `If this account does not belong to you, kindly download the <a
                            href="https://jombiz-staging-assets.s3.ap-southeast-1.amazonaws.com/dev/docs-pdf/JOMBIZ+STORE+3RD+PARTY+ACCOUNT+FORM.pdf"
                            target="_blank"
                          >
                            form,
                          </a>
                          fill out the required information, and send it to 
                          <a className="underline underline-offset-4" href="mailto:support@jommall.com">support@jommall.com</a>
                          or WhatsApp it to +60105074321 for verification purposes.`
                      },
                      {
                        type: "button",
                        buttonType: "link",
                        className: "p-0",
                        href: "https://jommall.com.s3.ap-southeast-1.amazonaws.com/dev/docs-pdf/JOMBIZ+STORE+3RD+PARTY+ACCOUNT+FORM.pdf",
                        target: "_blank",
                        children: [
                          {
                            type: "img",
                            style: { paddingLeft: '8px', width: "30px" },
                            src: "/Icons/272699_pdf_icon.svg"
                          }
                        ]
                      }
                    ]
                  }
                ]
              },
              { // upload bank statment
                type: 'div',
                className: 'row',
                children: [
                  {
                    type: 'div',
                    className: 'col-12',
                    children: [
                      {
                        type: 'text',
                        content: '<span style="color: #ff0000;">* </span> {{BANK_STATEMENT}}'
                      },
                      {
                        type: 'file-pond',
                        files: 'uploadedBankStatement',
                        acceptedFileTypes: ['image/*'],
                        allowMultiple: false,
                        returnFileInfo: true,
                        actionKey: 'UPLOAD_BANK_STATEMENT'
                      },
                      {
                        type: 'text',
                        isHide: 'hideFormFeedbackBankStatement',
                        className: 'text-danger',
                        content: "{{PLEASE_UPLOAD_BANK_STATEMENT}}"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          { // Security Pin
            type: 'card',
            title: {
              type: 'text',
              content: "{{SECURITY_PIN}}"
            },
            headStyle: { background: '$primary', color: '!primary' },
            children: [
              {
                type: 'div',
                className: 'row',
                children: [
                  {
                    type: 'div',
                    className: 'col-6',
                    children: [
                      {
                        type: 'input',
                        variant: 'password',
                        rules: [
                          { required: true, message: `{{PLEASE_ENTER}} {{SECURITY_PIN}}` },
                          { pattern: /^[\d]{6,6}$/, message: "{{SECURITY_PIN_ERROR}}" }
                        ],
                        label: "{{SECURITY_PIN}}",
                        name: 'security_pin',
                        inputConfig: {
                          placeholder: "{{SECURITY_PIN}}",
                          size: 'large'
                        }
                      }
                    ]
                  },
                  {
                    type: 'div',
                    className: 'col-6',
                    children: [
                      {
                        type: 'input',
                        variant: 'password',
                        rules: [
                          { required: true, message: `{{PLEASE_ENTER}} {{CONFIRM_SECURITY_PIN}}` },
                          { equal: 'security_pin', message: "{{SECURITY_PIN_CONFIRMATION_ERROR}}" }
                        ],
                        label: "{{CONFIRM_SECURITY_PIN}}",
                        name: 'security_pin_confirmation',
                        inputConfig: {
                          placeholder: "{{CONFIRM_SECURITY_PIN}}",
                          size: 'large'
                        }
                      }
                    ]
                  }
                ]
              }
            ]
          },
          { //section: submit button
            type: 'div',
            className: 'd-flex justify-content-end w-100',
            children: [
              {
                type: 'button',
                htmlType: 'submit',
                buttonType: 'text',
                className: 'custom-color my-3 ml-auto',
                style: {
                  backgroundColor: '$quaternary',
                  color: '#ffffff'
                },
                children: [
                  {
                    type: 'text',
                    content: "{{SUBMIT}}"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
}
